// ABOUTME: Shows WhatsApp application settings from the job view tab.
// ABOUTME: Reuses the recruiter flow editor with the current job data.
import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import useJobContext from "../useJobContext";
import WhatsappApplicationPanel from "../JobShare/WhatsappApplication/WhatsappApplicationPanel";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            padding: theme.spacing(2),
            marginBottom: theme.spacing(1)
        }
    })
);

const JobWhatsappApplicationMain = () => {
    const [data] = useJobContext();
    const classes = useStyles();
    const [editorOpen, setEditorOpen] = React.useState(false);
    const [refreshKey, setRefreshKey] = React.useState(0);
    const [t] = useTranslation("JOBSHAREMODULE", {
        useSuspense: false
    });
    const jobData = data?.Job?.data || {};
    const closeEditor = () => {
        setEditorOpen(false);
        setRefreshKey((current) => current + 1);
    };

    return (
        <>
            <WhatsappApplicationPanel
                t={t}
                classes={classes}
                jobId={String(data.JobId || "")}
                jobTitle={String(jobData.title || "")}
                pipeline={jobData.pipeline}
                screeningQuestionnaire={jobData.screeningQuestionnaire}
                enableScreeningQuestionnaire={
                    jobData.enableScreeningQuestionnaire === true
                }
                readonly={data.readonly}
                mode="summary"
                refreshKey={refreshKey}
                onEdit={() => setEditorOpen(true)}
            />
            <Dialog
                open={editorOpen}
                onClose={closeEditor}
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="lg"
                fullWidth
                scroll="body"
                aria-labelledby={t("whatsappApplicationTitle")}
            >
                <DialogTitle>{t("whatsappApplicationTitle")}</DialogTitle>
                <DialogContent dividers>
                    <WhatsappApplicationPanel
                        t={t}
                        classes={classes}
                        jobId={String(data.JobId || "")}
                        jobTitle={String(jobData.title || "")}
                        pipeline={jobData.pipeline}
                        screeningQuestionnaire={jobData.screeningQuestionnaire}
                        enableScreeningQuestionnaire={
                            jobData.enableScreeningQuestionnaire === true
                        }
                        readonly={data.readonly}
                        onUpdated={() =>
                            setRefreshKey((current) => current + 1)
                        }
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeEditor} color="secondary">
                        {t("whatsappApplicationClose")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default JobWhatsappApplicationMain;
